import React, { useEffect, useRef } from 'react';
import DsButton from '../../DsButton';
import DsModal from '../../DsModal';
import '../../../../css/common/chat/ChatTargetSearchModal.css';

const ChatTargetSearchModal = ({
  isOpen,
  title = '検索',
  onClose,
  onApply,
  onClear,
  applyLabel = '検索',
  clearLabel = 'クリア',
  disableApply = false,
  applying = false,
  errorMessage = '',
  onRetry,
  retrying = false,
  retryLabel = '再試行',
  summary = '',
  children,
}) => {
  const onApplyRef = useRef(onApply);
  const disableApplyRef = useRef(disableApply);
  const applyingRef = useRef(applying);

  onApplyRef.current = onApply;
  disableApplyRef.current = disableApply;
  applyingRef.current = applying;

  useEffect(() => {
    if (!isOpen) return undefined;
    const onKeyDown = (event) => {
      if (
        event.key === 'Enter' &&
        !event.isComposing &&
        !event.shiftKey &&
        !(disableApplyRef.current || applyingRef.current)
      ) {
        const target = event.target;
        if (!target || typeof target.closest !== 'function') return;
        if (!target.closest('.chat-target-search-modal')) return;
        const tag = String(target.tagName || '').toLowerCase();
        if (tag === 'textarea') return;
        event.preventDefault();
        if (typeof onApplyRef.current === 'function') onApplyRef.current();
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [isOpen]);

  if (!isOpen) return null;
  const hasError = !!String(errorMessage || '').trim();

  const footer = (
    <div className="chat-target-search-modal__footer-stack">
      {hasError ? (
        <div className="chat-target-search-modal__error" role="alert" aria-live="polite">
          <span className="chat-target-search-modal__error-text">{errorMessage}</span>
          {typeof onRetry === 'function' ? (
            <DsButton
              variant="danger"
              size="sm"
              className="chat-target-search-modal__error-retry"
              onClick={onRetry}
              disabled={retrying}
            >
              {retrying ? '再試行中…' : retryLabel}
            </DsButton>
          ) : null}
        </div>
      ) : null}
      <div className="chat-target-search-modal__footer-main">
        <div className="chat-target-search-modal__summary">{summary || ''}</div>
        <div className="chat-target-search-modal__actions">
          <DsButton
            variant="secondary"
            size="sm"
            className="chat-target-search-modal__action is-sub"
            onClick={() => {
              if (typeof onClear === 'function') onClear();
            }}
          >
            {clearLabel}
          </DsButton>
          <DsButton
            variant="primary"
            size="sm"
            className="chat-target-search-modal__action is-main"
            onClick={() => {
              if (typeof onApply === 'function') onApply();
            }}
            disabled={disableApply || applying}
          >
            {applying ? '検索中…' : applyLabel}
          </DsButton>
        </div>
      </div>
    </div>
  );

  return (
    <DsModal
      open={isOpen}
      onClose={onClose}
      title={title}
      size="md"
      className="chat-target-search-modal"
      footer={footer}
    >
      {children}
    </DsModal>
  );
};

export default ChatTargetSearchModal;
